import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';
import { EChargeBannerService } from '../../services/echarge-banner.service';

@Component({
  selector: 'app-download-button',
  standalone: false,
  templateUrl: './app-download-button.component.html',
  host: { class: 'inline-block' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppDownloadButtonComponent {
  protected readonly platform = inject(EChargeBannerService);
  public readonly downloadClicked = output<void>();
}
